import React from 'react'
import LandingView from 'components/LandingView/LandingView'
import LevelSelection from 'components/LevelSelection/LevelSelection'

import HospitalRoomScene, { ChosenInputMethod } from 'components/HospitalRoomScene/HospitalRoomScene'
import { RequestDeviceOrientation } from 'components/Controls/DeviceOrientationControls'
import { isMobile } from 'react-device-detect'
import './GalleryXR.css'

type GalleryXRProps = {}

type GalleryXRState = {
  showLandingScreen: boolean,
  showLevelSelectScreen: boolean,
  showCanvas: boolean,
  pageState: String
  inputMethod: ChosenInputMethod
  inputMethodInitialized: boolean,
  backgroundClass: string,
  canvasClass: string
}

class GalleryXR extends React.Component<GalleryXRProps, GalleryXRState> {
  constructor (props: JSX.IntrinsicAttributes) {
    super(props)

    this.state = {
      showLandingScreen: true,
      showLevelSelectScreen: false,
      showCanvas: false,
      pageState: 'Landing',
      inputMethod: 'Drag',
      inputMethodInitialized: false,
      backgroundClass: 'bg-transparent',
      canvasClass: 'opacity-0'
    }
  }

  handleStartClick = () => {
    this.setState({ showLevelSelectScreen: true, backgroundClass: 'bg-primary-lightBlue' })
    setTimeout(() => {
      this.setState({ showLandingScreen: false })
    }, 1000)
  }

  handleLevelSelect = (r: string) => {
    if (isMobile) {
      RequestDeviceOrientation(() => {
        this.setState({ inputMethod: 'Gyro', inputMethodInitialized: true })
      }, () => {
        this.setState({ inputMethod: 'Drag', inputMethodInitialized: true })
      })
    } else {
      this.setState({ inputMethodInitialized: true })
    }

    this.setState({ pageState: r, backgroundClass: 'bg-transparent', showCanvas: true })
    setTimeout(() => {
      this.setState({ showLevelSelectScreen: false, canvasClass: 'animation-fadeIn' })
    }, 500)
  }

  render = () => {
    return (
      <div className={'w-full h-body relative ' + this.state.backgroundClass}>
        {this.state.showLandingScreen && <LandingView startCallback={this.handleStartClick} />}
        {this.state.showLevelSelectScreen && <LevelSelection onSelection={this.handleLevelSelect} />}
        {this.state.showCanvas &&
          <div className={'w-full h-body relative ' + this.state.canvasClass}>
            {this.state.pageState === '3D01' && <HospitalRoomScene chosenInputMethod={this.state.inputMethod}
                                                                   inputInitialised={this.state.inputMethodInitialized} />}
          </div>}
      </div>
    )
  }
}

export default GalleryXR
